import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import Icon from "./src/icon.vue";
import svgIcon from "./src/svg-icon.vue";
export const xIcon = withInstall(Icon, { svgIcon });
export default xIcon;
export const xSvgIcon = withNoopInstall(svgIcon);
export * from "./src/svg-icon";
export * from "./src/icon";
